// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EDnv","right":"styles_right__1rSYk"};